import React from "react";
import { Collapse } from "antd";
import styled from "styled-components";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";

import themeColor from "../../lib/style/theme";

const { Panel } = Collapse;

const AdvancedSettings = ({ children }) => {
  return (
    <StyledCollapse>
      <Panel
        header={<FormattedMessage id="general.advancedSettings" defaultMessage="Advanced settings" />}
        key="advancedSettings"
        forceRender
      >
        {children}
      </Panel>
    </StyledCollapse>
  );
};

const StyledCollapse = styled(Collapse)`
  background-color: ${themeColor.orange} !important;
  width: 100%;
  margin: 15px 0;

  .ant-collapse-header {
    color: #fff !important;
  }
`;

AdvancedSettings.propTypes = {
  children: PropTypes.element.isRequired,
};

export default AdvancedSettings;
